import { LocalStorage } from "./localStorage"

export const Storage = {
    setSkill(skill) {
        LocalStorage.set("skill", skill);
    },
    skill() {
        return LocalStorage.get("skill");
    },
    potions() {
        return LocalStorage.get("potions");
    },
    setPotions(potions) {
        LocalStorage.set("potions", potions);
    },
    mwOn() {
        return LocalStorage.get("mwOn");
    },
    setMwOn(mwOn) {
        LocalStorage.set("mwOn", mwOn);
    },
    trOn() {
        return LocalStorage.get("trOn");
    },
    setTrOn(trOn) {
        LocalStorage.set("trOn", trOn);
    },
    bmOn() {
        return LocalStorage.get("bmOn");
    },
    setBmOn(bmOn) {
        LocalStorage.set("bmOn", bmOn);
    }
}